import styled from 'styled-components';

export const QuickActionsBox = styled.div`
  border-radius: 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #faf5ff 50%, #fdf2f8 100%);
  border: 1px solid #dbeafe;
  padding: 25px;
`;
export const ActionsTitle = styled.h4`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #212529;
  margin-bottom: 16px;
`;
export const ActionsItem = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0px;
  color: #314158;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  `}
`;
export const DateImg = styled.img``;
export const FollowUpsBox = styled.div`
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 22px;
  &.appointments-margin {
    margin-top: 16px;
  }
`;
export const FollowUpsTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0px;
  color: #212529;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const TitleImg = styled.img``;

export const FollowUpsContent = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FollowUpCard = styled.div`
  border-radius: 12px;
  padding: 16px;
  background-color: ${(props) => (props.status === 'done' ? '#ecfdf5' : '#eff6ff')};

  border: 2px solid ${(props) => (props.status === 'done' ? '#bbf7d0' : '#bfdbfe')};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  @media (max-width: 1570px) {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 4px;
  }
`;

export const CardDate = styled.p`
  font-weight: 700;
  font-size: 12px;
  color: #314158;
`;

export const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px 6px;
  border-radius: 16px;
  font-weight: 500;
  font-size: 10px;
  cursor: pointer;

  background-color: ${(props) => (props.status === 'pending' ? '#2b7fff1a' : '#d0fae5')};
  color: ${(props) => (props.status === 'pending' ? '#2d6cdf' : '#15c7a7')};

  .img-color {
    filter: ${(props) =>
      props.status === 'pending'
        ? 'invert(37%) sepia(93%) saturate(2206%) hue-rotate(206deg) brightness(98%) contrast(92%)'
        : 'invert(37%) sepia(85%) saturate(1450%) hue-rotate(134deg) brightness(95%) contrast(101%)'};
  }
  @media (max-width: 1570px) {
    align-self: flex-end;
  }
`;
export const StatusBadgeIcon = styled.img``;

export const CardAuthor = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #212529;
  margin-bottom: 4px;
`;

export const CardNote = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #6c757d;
  word-break: break-all;
`;
export const AppointmentCard = styled.div`
  background: #faf5ff;
  border: 1px solid #e9d4ff;
  border-radius: 10px;
  padding: 12px;
  margin-top: 12px;
`;

export const AppointmentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: ${(props) => (props.isSmallMargin ? '4px' : '0')};
  @media (max-width: 1570px) {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 4px;
  }
`;

export const InfoGroup = styled.div`
  display: flex;
  gap: ${(props) => (props.vertical ? '0px' : '4px')};
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
  margin-top: ${(props) => (props.vertical ? '4px' : '0px')};
`;

export const Label = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #212529;

  &.date-style {
    font-weight: 700;
  }
`;

export const Value = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${(props) => (props.isSecondary ? '#90a1b9' : '#6c757d')};
`;

export const DescriptionText = styled.p`
  font-weight: 400;
  font-size: 12px;
  color: #6c757d;
`;

export const AppointmentBadge = styled.div`
  background: #dbeafe;
  color: #2d6cdf;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 10px;
  font-weight: 500;
  @media (max-width: 1570px) {
    align-self: flex-end;
  }
`;
export const NoteCard = styled.div`
  background: #fffbeb;
  border: 2px solid #fee685;
  border-radius: 10px;
  padding: 14px 14px 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NoteTitle = styled.h5`
  font-weight: 500;
  font-size: 14px;
  color: #212529;
`;

export const NoteDescription = styled.p`
  font-weight: 400;
  font-size: 12px;
  color: #6c757d;
`;

export const NoteFooter = styled.div`
  font-weight: 400;
  font-size: 10px;
  color: #90a1b9;
`;
